import { Reveal } from "@/lib/motion";
import { DOC_CONFIG } from "@/config/site";
import { ArrowUpRight, FileText } from "lucide-react";

export default function FinalCta() {
  return (
    <section id="final-cta" className="relative overflow-hidden py-28 sm:py-36" data-testid="final-cta">
      <div className="absolute inset-0 -z-10 grid-bg opacity-40" />
      <div className="absolute left-1/2 top-1/2 -z-10 h-[400px] w-[700px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-indigo-700/15 blur-[150px]" />

      <div className="mx-auto w-full max-w-4xl px-5 text-center sm:px-8">
        <Reveal className="flex flex-col items-center">
          <span className="inline-flex items-center gap-2.5 rounded-full border border-white/15 bg-white/5 px-4 py-2 backdrop-blur-md">
            <span className="relative flex h-2 w-2">
              <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-emerald-400 opacity-70" />
              <span className="relative inline-flex h-2 w-2 rounded-full bg-emerald-400" />
            </span>
            <span className="font-mono text-[11px] uppercase tracking-[0.24em] text-white">Presale Starts Nov 1, 2026</span>
          </span>

          <h2 className="mt-8 font-display text-4xl font-black uppercase leading-[0.98] tracking-tighter text-white sm:text-6xl lg:text-7xl">
            The Next Phase<br />
            <span className="text-gradient-indigo">Starts Here.</span>
          </h2>

          <p className="mt-7 max-w-2xl text-base leading-relaxed text-gray-400 sm:text-lg">
            Explore the vision. Understand the economics. Participate in the beginning of the
            Xenovia Prime ecosystem.
          </p>

          <div className="mt-10 flex flex-col gap-3 sm:flex-row">
            <a
              href={DOC_CONFIG.whitepaperUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="group inline-flex items-center justify-center gap-2 rounded-full bg-white px-9 py-4 font-mono text-sm font-bold uppercase tracking-[0.14em] text-black transition-all hover:bg-indigo-400 hover:text-white"
              data-testid="final-read-whitepaper"
            >
              <FileText className="h-4 w-4" />
              Read Whitepaper
              <ArrowUpRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </a>
            <button
              onClick={() => {
                const el = document.querySelector("#presale");
                if (window.__lenis) window.__lenis.scrollTo(el, { immediate: false });
                else if (el) el.scrollIntoView({ behavior: "smooth" });
              }}
              className="inline-flex items-center justify-center gap-2 rounded-full border border-white/20 px-9 py-4 font-mono text-sm font-bold uppercase tracking-[0.14em] text-white transition-all hover:border-white/50 hover:bg-white/5"
              data-testid="final-view-presale"
            >
              View Presale Details
            </button>
          </div>

          <div className="mt-10 font-mono text-[11px] uppercase tracking-[0.3em] text-gray-600">
            Presale • Pre-Launch • XVPR
          </div>
        </Reveal>
      </div>
    </section>
  );
}
